import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-you-there-dialog',
  templateUrl: './you-there-dialog.component.html',
  styleUrls: ['./you-there-dialog.component.scss']
})
export class YouThereDialogComponent implements OnInit {
  secondsLeft = 30;
  constructor(private dialog:MatDialogRef<YouThereDialogComponent>) { }

  ngOnInit(): void {
    setInterval(()=>{
      if(this.secondsLeft === 0) this.closeDialog(400)
      this.secondsLeft -=1;
    }, 1000)
  }

  closeDialog(code){
    this.dialog.close(code)
  }

}
